import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'col-span-full row-span-full -mx-8 -mt-4 -mb-8 min-h-0 min-w-0 overflow-y-auto px-8 pt-4 pb-8 ' +
            'scrollbar-thin [scrollbar-color:var(--gray-alpha-50)_transparent] [&::-webkit-scrollbar]:w-1.5 ' +
            '[&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-(--gray-alpha-50) ' +
            '[&::-webkit-scrollbar-track]:bg-transparent',
        content: 'flex h-full min-h-144 flex-col pb-4 max-wide:pb-0'
    }
} satisfies ComponentTheme;
